let bookRowIndex = 1;

document.getElementById('addBookRow').addEventListener('click', function () {
    const container = document.getElementById('bookRows');
    const lastRow = container.querySelector('.book-row:last-child');
    const newRow = lastRow.cloneNode(true);

    // Clear values
    newRow.querySelectorAll('input').forEach(input => {
        input.value = input.type === 'number' ? 1 : '';
        input.classList.remove('field--error');
    });

    newRow.querySelectorAll('.field').forEach(field => {
        field.classList.remove('has-error');
        const errorEl = field.querySelector('.custom-error');
        if (errorEl) errorEl.remove();
    });

    newRow.querySelector('.remove-row').style.display = 'inline-block';
    newRow.querySelector('.remove-row').addEventListener('click', function () {
        newRow.remove();
    });

    container.appendChild(newRow);
    bookRowIndex++;
});
  
document.getElementById('QuoteFormSubmit').addEventListener('click', function (e) {
    const form = document.getElementById('QuoteForm');
    let hasErrors = false;
    var phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    const isbnRegex = /^\d{9,13}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const requiredFields = form.querySelectorAll('[required]');

    form.querySelectorAll('.field').forEach(fieldWrapper => {
        const input = fieldWrapper.querySelector('input, select');
        if (input) input.classList.remove('field--error');
        fieldWrapper.classList.remove('has-error');
        const errorEl = fieldWrapper.querySelector('.custom-error');
        if (errorEl) errorEl.remove();
    });

    requiredFields.forEach(field => {
        const value = field.value.trim();
        const fieldWrapper = field.closest('.field');

        // Check if empty after trim
        if (!value || (field.type === 'tel' && !phoneRegex.test(value)) || (field.type === 'email' && !emailRegex.test(value))) {
        hasErrors = true;
        field.classList.add('field--error');

        if (fieldWrapper) {
            fieldWrapper.classList.add('has-error');
            const error = document.createElement('small');
            error.classList.add('custom-error');

            if (!value) {
                error.textContent = 'This field is required.';
            } else if (field.type === 'tel') {
                error.textContent = 'Please enter a valid phone number.';
            } else if (field.type === 'email') {
                error.textContent = 'Please enter a valid email address.';
            }
            fieldWrapper.appendChild(error);
        }
        }
    });

    
    const rows = document.querySelectorAll('.book-row');

    rows.forEach((row, index) => {
        const qtyInput = row.querySelector('[data-label="Quantity"]');
        const isbnInput = row.querySelector('[data-label="ISBN"]');
        const titleInput = row.querySelector('[data-label="Title"]');

        qtyInput.name = `contact[Book ${index + 1} Quantity]`;
        isbnInput.name = `contact[Book ${index + 1} ISBN]`;
        titleInput.name = `contact[Book ${index + 1} Title]`;

        const isbnValue = isbnInput.value.trim();
        const isbnWrapper = isbnInput.closest('.field');

        // Optional ISBN validation
        if (isbnValue !== '' && !isbnRegex.test(isbnValue)) {
            hasErrors = true;
            isbnInput.classList.add('field--error');
            if (isbnWrapper) {
                isbnWrapper.classList.add('has-error');
                const error = document.createElement('small');
                error.classList.add('custom-error');
                error.textContent = 'ISBN must be 9–13 numeric digits.';
                isbnWrapper.appendChild(error);
            }
        }
    
        if (!hasErrors) {
            form.submit();
        }
    });
});